module.exports = __webpack_public_path__ + "img/Kanto-Ads-logo-icon.dede1c9c.svg";